
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import layout from './layout.vue'
import QualificationItem from '@/components/qualification-item'

@Component({
  name: 'ItemList',
  components: {
    layout,
    QualificationItem
  },
  filters: {}
})
export default class ItemList extends Vue {
  @Prop({ type: Array, default: () => [] }) list: Array<any>
  @Prop({ type: String, default: '' }) title: string
  @Prop({ type: Boolean, default: false }) moduleError: boolean
  @Prop({ type: Number, default: null }) currentOrder: number
  @State('formData', { namespace: 'qualification' }) formData: any
  @State('showRules', { namespace: 'qualification' }) showRules: any
  @Action('qualification/updateFormData') updateFormData: Function
  @Action('qualification/updateCellDetail') updateCellDetail: Function

  show = false
  loading = false
  currentFormData = {}

  @Watch('show', { immediate: true })
  onShowChange(val) {
    val && this.setDefaultCurrentFormData()
  }

  get filterList() {
    return this.list?.filter((i) => !i.hidden)
  }

  isLink(data) {
    return data.component !== 'input' && !data?.disabled
  }
  isDisabled(data) {
    return !!data?.disabled
  }
  openItemList() {
    this.show = true
    this.moduleError && setTimeout(() => this.validator())
  }
  handleBack() {
    if (!this.formData.state || this.formData.state === -1) {
      this.updateCellDetail({ name: 'state', value: this.formData.state, formIndex: this.$route.query?.formIndex })
    }
    this.setDefaultCurrentFormData()
    this.show = false
    this.loading = false
  }
  async handleOk() {
    if (this.loading) true
    this.loading = true
    const validate = await this.validator()
    if (!validate) {
      this.loading = false
      return
    }
    this.updateFormData(this.currentFormData)
    const vat_value_check = Object.keys(
      this.currentFormData?.tax_value || {}
    )?.includes('vat')
    if (vat_value_check) {
      this.updateCellDetail({
        name: 'vat',
        value: this.currentFormData?.tax_value?.vat,
        formIndex: this.$route.query?.formIndex
      })
    }
    this.$emit('updateModuleError', false)
    this.show = false
    this.loading = false
  }
  updateValue(data) {
    this.currentFormData = { ...this.currentFormData, ...data }
  }
  cellDetailChange(data) {
    this.updateCellDetail({ ...data, formIndex: this.$route.query?.formIndex})
  }
  async validator() {
    let result = true
    const len = this.$refs?.nameRef.length
    for (let i = 0; i < len; i++) {
      const validate = await this.$refs?.nameRef[i]?.validator()
      if (validate === false) {
        result = false
      }
    }
    console.log('result----', result)
    return result
  }
  setDefaultCurrentFormData() {
    this.list.map((i) => {
      const key = i?.field
      if (key === 'tax_type') {
        this.updateCellDetail({
          field: 'tax_value',
          selectTaxType: this.formData?.[key],
          formIndex: this.$route.query?.formIndex
        })
      }
      this.currentFormData[key] = this.formData?.[key]
    })
  }
}
